<div class="general-body">
    <div class="body-container">
        <!--  start of Vendor application header -->
        <div class="vendor-application">
            <div class="vendor-title d-flex align-items-center gap-2 flex-wrap">
                <h4>Vendor Application</h4>
                <span class="vendor-application-status-badge" *ngIf="getVendorStatusDisplay()" [ngClass]="getVendorStatusBadgeClass()">
                    {{ getVendorStatusDisplay() }}
                </span>
            </div>
            <div class="container vendor-status-road">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb d-flex align-items-center">
                        <li>
                            <span class="dashboard-road">
                              Dashboard
                              <svg class="chevv" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                  fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd"
                                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                              </svg>
                          </span>
                        </li>
                        <li>
                            <span class="status-road">
                              Vendor Status
                              <svg class="chevv" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                  fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd"
                                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                              </svg>
                          </span>
                        </li>
                        <li aria-current="page">
                            <span class="vendor-apllication-road"> Vendor Application </span>
                        </li>
                    </ol>
                </nav>
            </div>
            <app-progress-bar [currentStep]="currentTab" [steps]="steps"></app-progress-bar>
            <div class="alert alert-info primary-contact-message mb-4 mt-3" *ngIf="user?.ContactType === 'Primary'" role="alert">
                <i class="bi bi-info-circle-fill me-2"></i>
                <strong>You are the primary contact.</strong> You are the only one who can submit and update the vendor application.
            </div>
            <div class="alert alert-warning primary-contact-message mb-4 mt-3" *ngIf="latestChangeRequestComments && (vendor?.Status?.toLowerCase() === 'changerequested' || vendor?.Status?.toLowerCase() === 'change requested')" role="alert">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                <strong>Change requested: </strong>
                <span>{{ latestChangeRequestComments }}</span>
            </div>
        </div>
        <!--  end of Vendor application header -->
        <!-- Supplier Information Tab -->
        <form *ngIf="steps[currentTab]?.title === 'Supplier Information' && GeneralFormTab" [formGroup]="GeneralFormTab">
            <div>
                <div>





                </div>
            </div>
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields">
                        <div class="mandatory-line">

                        </div>
                    </div>

                    <div class="container pt-4">
                        <div class="email-reg row">
                            <div class="col-12 col-md-6 d-flex">
                                <div class="acc-type-f fw-bold col-4">
                                    <span>Account type:</span>
                                </div>
                                <div class="acc-type-s col-8">
                                    <span>{{ vendor.vendorType }}</span>
                                    <!-- string >> Individual, Organization, Investor -->
                                </div>
                            </div>

                            <div class="col-12 col-md-6 d-flex pt-md-0 pt-4">
                                <div class="acc-type-f fw-bold col-4">
                                    <span>Local / Foreign:</span>
                                </div>
                                <div class="acc-type-s col-8">
                                    <span>{{ vendor.localOrForeign }}</span>
                                </div>
                            </div>

                        </div>
                        <br>

                        <div class="phone-num row">







                            <div class="col-12 col-md-6 d-flex">
                                <div class="acc-type-f fw-bold col-4">
                                    <span>{{vendor.vendorType == vendorType.Individual ? "Person Name" : "Company Name"  }}</span>
                                </div>
                                <div class="acc-type-s col-8">
                                    <span>{{ vendor.vendorName }}</span>
                                    <!-- string >> Individual, Organization, Investor -->
                                </div>
                            </div>

                            <div class="col-12 col-md-6 d-flex pt-md-0 pt-4">
                                <div class="acc-type-f fw-bold col-4">
                                    <span>VendorID: </span>
                                </div>
                                <div class="acc-type-s col-8">
                                    <span>{{ vendor.ERPVendorID }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields"></div>
                    <div class="container pt-4">
                        <div class="mandatory-line">
                            <span class="mandatory-par">
                              Mandatory fields below are marked with <span style="color: red;font-size: 1rem;">*</span>
                            </span>
                        </div>
                        <br>

                        <!-- Company Name and Nature of Business -->
                        <div class="row mb-4" *ngIf="vendor?.vendorType !== 'Individual'">
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="companyName" class="form-label fw-bold" appRequiredField="companyName">Company Name</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="companyName" formControlName="companyName" placeholder="Enter company name" />
                                    <div class="text-danger" *ngIf="
                                        GeneralFormTab.get('companyName')?.invalid &&
                                        (GeneralFormTab.get('companyName')?.dirty || GeneralFormTab.get('companyName')?.touched)
                                    ">
                                        <div *ngIf="GeneralFormTab.get('companyName')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="natureOfBusiness" class="form-label fw-bold" appRequiredField="natureOfBusiness">Nature of Business</label>
                                    <select class="form-control rounded-4 bg-light p-2" formControlName="natureOfBusiness" id="natureOfBusiness" [disabled]="isViewMode">
                                        <option value="">Select Nature of Business</option>
                                        <option *ngFor="let option of natureOfBusinessOptions" [value]="option">
                                            {{ option }}
                                        </option>
                                    </select>
                                    <div class="text-danger" *ngIf="
                                        GeneralFormTab.get('natureOfBusiness')?.invalid &&
                                        (GeneralFormTab.get('natureOfBusiness')?.dirty || GeneralFormTab.get('natureOfBusiness')?.touched)
                                    ">
                                        <div *ngIf="GeneralFormTab.get('natureOfBusiness')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Company Nature (Single Selection) -->
                        <div class="row mb-4" *ngIf="vendor?.vendorType !== 'Individual'">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="companyType" class="form-label fw-bold" appRequiredField="companyType">Company Nature</label>
                                    <select class="form-control rounded-4 bg-light p-2" id="companyType" formControlName="companyType" [disabled]="isViewMode" (change)="onCompanyTypeChange()">
                                        <option value="">Select Company Nature</option>
                                        <option *ngFor="let companyType of companyTypes" [value]="companyType">
                                            {{ companyType }}
                                        </option>
                                    </select>
                                    <div class="text-danger" *ngIf="
                                        GeneralFormTab.get('companyType')?.invalid &&
                                        (GeneralFormTab.get('companyType')?.dirty || GeneralFormTab.get('companyType')?.touched)
                                    ">
                                        <div *ngIf="GeneralFormTab.get('companyType')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Other (please specify) -->
                        <div class="row mb-4" *ngIf="vendor?.vendorType !== 'Individual' && GeneralFormTab.get('companyType')?.value === 'Other'">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="otherCompanyType" class="form-label fw-bold" appRequiredField="otherCompanyType">Other (please specify):</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="otherCompanyType" formControlName="otherCompanyType" placeholder="Please specify other company type" />
                                    <div class="text-danger" *ngIf="
                                        GeneralFormTab.get('otherCompanyType')?.invalid &&
                                        (GeneralFormTab.get('otherCompanyType')?.dirty || GeneralFormTab.get('otherCompanyType')?.touched)
                                    ">
                                        <div *ngIf="GeneralFormTab.get('otherCompanyType')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Contacts Section (multiple contacts) -->
                        <div class="address-title mb-3">
                            <h4 class="fw-bold">Contacts</h4>
                        </div>
                        <div class="alert alert-info rounded-4 mb-3" role="note">
                            <p class="mb-1"><strong>Important:</strong> When your vendor application is approved, the contacts listed below will be invited to the system and vendor portal accounts will be created for them. They will then be able to participate in tenders published by Bidaya.</p>
                            <p class="mb-0">Please ensure that the <strong>email</strong> and <strong>mobile number</strong> for each contact are correct and actively used, as they will be used for OTP and login purposes. If you need to update a contact's email after approval, please contact Bidaya.</p>
                        </div>
                        <div class="py-1 mb-3">
                            <button type="button" class="btn btn-add" *ngIf="!isViewMode" aria-label="Add new contact" (click)="addPrimaryContact()">
                                Add new contact <i class="bi bi-plus"></i>
                            </button>
                        </div>
                        <div formArrayName="primaryContacts" class="mb-4">
                            <ng-container *ngFor="let contact of primaryContacts.controls; let i = index">
                                <div class="inner-card mb-3" [formGroupName]="i">
                                    <div class="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
                                        <i class="bi" [ngClass]="i === 0 ? 'bi-person-fill text-primary' : 'bi-person-plus text-secondary'"></i>
                                        <span class="badge" [ngClass]="i === 0 ? 'bg-primary' : 'bg-secondary'">
                                            {{ i === 0 ? 'Primary contact' : 'Secondary contact' }}
                                        </span>
                                    </div>
                                    <div class="row">
                                        <!-- Name, Mob No., Email grouped together -->
                                        <div class="col-12 col-md-4">
                                            <div class="mb-3">
                                                <label [attr.for]="'primaryContactName-' + i" class="form-label fw-bold" appRequiredField="name">Name</label>
                                                <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'primaryContactName-' + i" formControlName="name" placeholder="Enter name" [readonly]="i === 0" />
                                                <div class="text-danger" *ngIf="
                                                    contact.get('name')?.invalid &&
                                                    (contact.get('name')?.dirty || contact.get('name')?.touched)
                                                ">
                                                    <div *ngIf="contact.get('name')?.errors?.['required']">
                                                        This field is required
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <app-mobile-input [form]="getPrimaryContactForm(i)" mobileControlName="mobNo" label="Mob No." labelClass="form-label fw-bold" [readonly]="i === 0"></app-mobile-input>
                                            <div class="text-danger small" *ngIf="contact.get('mobNo')?.errors?.['contactMobileExists']">
                                                {{ contact.get('mobNo')?.errors?.['contactMobileExists'] }}
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <div class="mb-3">
                                                <label [attr.for]="'primaryContactEmail-' + i" class="form-label fw-bold" appRequiredField="email">Email</label>
                                                <input type="email" class="form-control rounded-4 bg-light p-2" [id]="'primaryContactEmail-' + i" formControlName="email" placeholder="Enter email" [readonly]="i === 0" />
                                                <div class="text-danger" *ngIf="
                                                    contact.get('email')?.invalid &&
                                                    (contact.get('email')?.dirty || contact.get('email')?.touched)
                                                ">
                                                    <div *ngIf="contact.get('email')?.errors?.['required']">
                                                        This field is required
                                                    </div>
                                                    <div *ngIf="contact.get('email')?.errors?.['email']">
                                                        Please enter a valid email
                                                    </div>
                                                    <div *ngIf="contact.get('email')?.errors?.['contactEmailExists']">
                                                        {{ contact.get('email')?.errors?.['contactEmailExists'] }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <div class="mb-3">
                                                <label [attr.for]="'primaryContactTitle-' + i" class="form-label fw-bold">Title</label>
                                                <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'primaryContactTitle-' + i" formControlName="title" placeholder="Enter title" />
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <app-mobile-input [form]="getPrimaryContactForm(i)" mobileControlName="telNo" label="Tel No." labelClass="form-label fw-bold"></app-mobile-input>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end align-items-center py-2">
                                        <a class="btn btn-save" (click)="deletePrimaryContact(i)" *ngIf="!isViewMode && primaryContacts.controls.length > 1 && i > 0">
                                            Delete
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <!-- Main Office / Headquarters: Correspondence Address -->
                        <div class="address-title mb-3 mt-4">
                            <h4 class="fw-bold">Main Office / Headquarters: Correspondence Address</h4>
                        </div>
                        <div formGroupName="mainOffice" class="mb-4">
                            <div class="row">
                                <!-- Left Column: Address Fields -->
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="poBox" class="form-label fw-bold">P.O. Box</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="poBox" formControlName="poBox" placeholder="Enter P.O. Box" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="street" class="form-label fw-bold" appRequiredField="mainOffice.street">Street Name</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="street" formControlName="street" placeholder="Enter street name" />
                                        <div class="text-danger" *ngIf="
                                            GeneralFormTab.get('mainOffice.street')?.invalid &&
                                            (GeneralFormTab.get('mainOffice.street')?.dirty || GeneralFormTab.get('mainOffice.street')?.touched)
                                        ">
                                            <div *ngIf="GeneralFormTab.get('mainOffice.street')?.errors?.['required']">
                                                This field is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="zoneNo" class="form-label fw-bold">Zone No.<span *ngIf="isQatarCountry(GeneralFormTab.get('mainOffice.country')?.value)" style="color: red; font-weight: bold; margin-left: 2px;">*</span></label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="zoneNo" formControlName="zoneNo" placeholder="Enter zone no" />
                                        <div class="text-danger" *ngIf="GeneralFormTab.get('mainOffice.zoneNo')?.invalid && (GeneralFormTab.get('mainOffice.zoneNo')?.dirty || GeneralFormTab.get('mainOffice.zoneNo')?.touched)">
                                            <div *ngIf="GeneralFormTab.get('mainOffice.zoneNo')?.errors?.['required']">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="streetNo" class="form-label fw-bold">Street No.<span *ngIf="isQatarCountry(GeneralFormTab.get('mainOffice.country')?.value)" style="color: red; font-weight: bold; margin-left: 2px;">*</span></label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="streetNo" formControlName="streetNo" placeholder="Enter street no" />
                                        <div class="text-danger" *ngIf="GeneralFormTab.get('mainOffice.streetNo')?.invalid && (GeneralFormTab.get('mainOffice.streetNo')?.dirty || GeneralFormTab.get('mainOffice.streetNo')?.touched)">
                                            <div *ngIf="GeneralFormTab.get('mainOffice.streetNo')?.errors?.['required']">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="buildingNo" class="form-label fw-bold">Building No.<span *ngIf="isQatarCountry(GeneralFormTab.get('mainOffice.country')?.value)" style="color: red; font-weight: bold; margin-left: 2px;">*</span></label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="buildingNo" formControlName="buildingNo" placeholder="Enter building no" />
                                        <div class="text-danger" *ngIf="GeneralFormTab.get('mainOffice.buildingNo')?.invalid && (GeneralFormTab.get('mainOffice.buildingNo')?.dirty || GeneralFormTab.get('mainOffice.buildingNo')?.touched)">
                                            <div *ngIf="GeneralFormTab.get('mainOffice.buildingNo')?.errors?.['required']">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="city" class="form-label fw-bold" appRequiredField="mainOffice.city">City</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="city" formControlName="city" placeholder="Enter city" />
                                        <div class="text-danger" *ngIf="
                                            GeneralFormTab.get('mainOffice.city')?.invalid &&
                                            (GeneralFormTab.get('mainOffice.city')?.dirty || GeneralFormTab.get('mainOffice.city')?.touched)">
                                            <div *ngIf="GeneralFormTab.get('mainOffice.city')?.errors?.['required']">
                                                This field is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Right Column: Contact Fields -->
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="state" class="form-label fw-bold">State/Region/Province</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="state" formControlName="state" placeholder="Enter state/region/province" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="mainOfficeCountry" class="form-label fw-bold" appRequiredField="mainOffice.country">Country</label>
                                        <select class="form-control rounded-4 bg-light p-2" formControlName="country" id="mainOfficeCountry">
                                            <option value="">Choose Country</option>
                                            <option *ngFor="let country of Countries" [value]="country.countryRegionId">
                                                {{ country.countryName }}
                                            </option>
                                        </select>
                                        <div class="text-danger" *ngIf="
                                            GeneralFormTab.get('mainOffice.country')?.invalid &&
                                            (GeneralFormTab.get('mainOffice.country')?.dirty || GeneralFormTab.get('mainOffice.country')?.touched)">
                                            <div *ngIf="GeneralFormTab.get('mainOffice.country')?.errors?.['required']">
                                                This field is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <app-mobile-input [form]="mainOfficeForm" mobileControlName="telephone" label="Telephone No." labelClass="form-label fw-bold"></app-mobile-input>
                                    </div>
                                    <div class="mb-3">
                                        <label for="fax" class="form-label fw-bold">Fax No.</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="fax" formControlName="fax" placeholder="Enter fax number" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="mainOfficeEmail" class="form-label fw-bold">Email</label>
                                        <input type="email" class="form-control rounded-4 bg-light p-2" id="mainOfficeEmail" formControlName="email" placeholder="Enter email" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="mainOfficeWebsite" class="form-label fw-bold">Website</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="mainOfficeWebsite" formControlName="website" placeholder="Enter website" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Establishment and Employees -->
                        <div formGroupName="establishment" class="mb-4" *ngIf="vendor?.vendorType !== 'Individual'">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="establishmentCountry" class="form-label fw-bold" appRequiredField="establishment.country">Country of Establishment</label>
                                        <select class="form-control rounded-4 bg-light p-2" formControlName="country" id="establishmentCountry">
                                            <option value="">Choose Country</option>
                                            <option *ngFor="let country of Countries" [value]="country.countryRegionId">
                                                {{ country.countryName }}
                                            </option>
                                        </select>
                                        <div class="text-danger" *ngIf="GeneralFormTab.get('establishment.country')?.invalid && (GeneralFormTab.get('establishment.country')?.dirty || GeneralFormTab.get('establishment.country')?.touched)">
                                            <div *ngIf="GeneralFormTab.get('establishment.country')?.errors?.['required']">This field is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="establishmentYear" class="form-label fw-bold">Year</label>
                                        <input type="number" class="form-control rounded-4 bg-light p-2" id="establishmentYear" formControlName="year" placeholder="Enter year" />
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="mb-3">
                                        <label for="numberOfEmployees" class="form-label fw-bold">Number of Employees</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="numberOfEmployees" formControlName="employees" placeholder="Enter number of employees" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Parent Company Information -->
                        <div formGroupName="parentCompany" class="mb-4" *ngIf="vendor?.vendorType !== 'Individual'">
                            <div class="row">
                                <!-- <div class="col-12">
                                    <div class="mb-3">
                                        <label for="parentCompanyName" class="form-label fw-bold">Parent Company Name (if different to above):</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="parentCompanyName" formControlName="name" placeholder="Enter parent company name" />
                                    </div>
                                </div> -->
                                <div class="col-12">
                                    <div class="mb-3">
                                        <div class="d-flex align-items-center gap-3 flex-wrap">
                                            <span class="form-label fw-bold mb-0">
                                                Parent Company Name (if different to above):
                                            </span>
                                            <div class="custom-radio-toggle-group">
                                                <label class="custom-radio-toggle" [class.active]="GeneralFormTab.get('parentCompany.isDifferent')?.value === true">
                                                    <input type="radio" name="isDifferent" id="parentCompanyYes" [value]="true" formControlName="isDifferent" class="custom-radio-input" />
                                                    <span class="custom-radio-label">Yes</span>
                                                </label>
                                                <label class="custom-radio-toggle" [class.active]="GeneralFormTab.get('parentCompany.isDifferent')?.value === false">
                                                    <input type="radio" name="isDifferent" id="parentCompanyNo" [value]="false" formControlName="isDifferent" class="custom-radio-input" />
                                                    <span class="custom-radio-label">No</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" *ngIf="GeneralFormTab.get('parentCompany.isDifferent')?.value === true">
                                    <div class="mb-3">
                                        <label for="previousName" class="form-label fw-bold">If yes, What is the name of the parent company?</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="previousName" formControlName="previousName" placeholder="Enter parent company name" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Subsidiaries -->
            <div class="mandatory-application m-4" *ngIf="vendor?.vendorType !== 'Individual'">
                <div class="inside-out p-4">
                    <div class="mandatory-fields"></div>
                    <div class="container pt-4">
                        <div class="address-title mb-3">
                            <h4 class="fw-bold">Subsidiaries</h4>
                        </div>
                        
                        <!-- Yes/No Toggle for Subsidiaries -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <div class="d-flex align-items-center gap-3 flex-wrap">
                                        <span class="form-label fw-bold mb-0">
                                            Do you have subsidiaries?
                                        </span>
                                        <div class="custom-radio-toggle-group">
                                            <label class="custom-radio-toggle" [class.active]="hasSubsidiaries === true">
                                                <input type="radio" name="hasSubsidiaries" id="hasSubsidiariesYes" [value]="true" [checked]="hasSubsidiaries === true" (change)="onSubsidiariesToggle(true)" [disabled]="isViewMode" class="custom-radio-input" />
                                                <span class="custom-radio-label">Yes</span>
                                            </label>
                                            <label class="custom-radio-toggle" [class.active]="hasSubsidiaries === false">
                                                <input type="radio" name="hasSubsidiaries" id="hasSubsidiariesNo" [value]="false" [checked]="hasSubsidiaries === false" (change)="onSubsidiariesToggle(false)" [disabled]="isViewMode" class="custom-radio-input" />
                                                <span class="custom-radio-label">No</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div *ngIf="hasSubsidiaries">
                            <div class="py-1 mb-3">
                                <button class="btn btn-add" *ngIf="!isViewMode" aria-label="Add new subsidiary" (click)="addSubsidiary()">
                                    Add new subsidiary <i class="bi bi-plus"></i>
                                </button>
                            </div>
                            
                            <div formArrayName="subsidiaries">
                            <!-- First Subsidiary (Static with Company Nature) -->
                            <div class="inner-card mb-3" *ngIf="subsidiaries.controls.length > 0" [formGroupName]="0">
                                <!-- Subsidiary Name and Relationship to Parent -->
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'subsidiaryName-0'" class="form-label fw-bold" appRequiredField="subsidiaryName">Subsidiary Name</label>
                                            <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'subsidiaryName-0'" formControlName="subsidiaryName" placeholder="Enter subsidiary name" />
                                            <div class="text-danger" *ngIf="
                                                subsidiaries.controls[0].get('subsidiaryName')?.invalid &&
                                                (subsidiaries.controls[0].get('subsidiaryName')?.dirty || subsidiaries.controls[0].get('subsidiaryName')?.touched)">
                                                <div *ngIf="subsidiaries.controls[0].get('subsidiaryName')?.errors?.['required']">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'relationshipToParent-0'" class="form-label fw-bold" appRequiredField="relationshipToParent">Relationship to Parent</label>
                                            <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'relationshipToParent-0'" formControlName="relationshipToParent" placeholder="Enter relationship to parent" />
                                            <div class="text-danger" *ngIf="
                                                subsidiaries.controls[0].get('relationshipToParent')?.invalid &&
                                                (subsidiaries.controls[0].get('relationshipToParent')?.dirty || subsidiaries.controls[0].get('relationshipToParent')?.touched)">
                                                <div *ngIf="subsidiaries.controls[0].get('relationshipToParent')?.errors?.['required']">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="d-flex justify-content-end align-items-center py-2">
                                    <a class="btn btn-save" (click)="deleteSubsidiary(0)" *ngIf="!isViewMode">
                                        Delete
                                    </a>
                                </div>
                            </div>
                            
                            <!-- Additional Subsidiaries (Name, Relationship, and Company Nature) -->
                            <ng-container *ngFor="let subsidiary of subsidiaries.controls; let i = index">
                                <div class="inner-card mb-3" *ngIf="i > 0" [formGroupName]="i">
                                <!-- Subsidiary Name and Relationship to Parent -->
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'subsidiaryName-' + i" class="form-label fw-bold" appRequiredField="subsidiaryName">Subsidiary Name</label>
                                            <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'subsidiaryName-' + i" formControlName="subsidiaryName" placeholder="Enter subsidiary name" />
                                            <div class="text-danger" *ngIf="
                                                subsidiary.get('subsidiaryName')?.invalid &&
                                                (subsidiary.get('subsidiaryName')?.dirty || subsidiary.get('subsidiaryName')?.touched)">
                                                <div *ngIf="subsidiary.get('subsidiaryName')?.errors?.['required']">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'relationshipToParent-' + i" class="form-label fw-bold" appRequiredField="relationshipToParent">Relationship to Parent</label>
                                            <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'relationshipToParent-' + i" formControlName="relationshipToParent" placeholder="Enter relationship to parent" />
                                            <div class="text-danger" *ngIf="
                                                subsidiary.get('relationshipToParent')?.invalid &&
                                                (subsidiary.get('relationshipToParent')?.dirty || subsidiary.get('relationshipToParent')?.touched)">
                                                <div *ngIf="subsidiary.get('relationshipToParent')?.errors?.['required']">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="d-flex justify-content-end align-items-center py-2">
                                    <a class="btn btn-save" (click)="deleteSubsidiary(i)" *ngIf="!isViewMode">
                                        Delete
                                    </a>
                                </div>
                                </div>
                            </ng-container>
                        </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Additional Information -->
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields"></div>
                    <div class="container pt-4">
                        <div class="address-title mb-3">
                            <h4 class="fw-bold">Additional Information</h4>
                        </div>
                        <div formGroupName="additionalInfo">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="commercialReg" class="form-label fw-bold" appRequiredField="commercialReg">Commercial Registration Number</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="commercialReg" formControlName="commercialReg" placeholder="Enter commercial registration number" />
                                        <div class="text-danger" *ngIf="
                                            GeneralFormTab.get('additionalInfo.commercialReg')?.invalid &&
                                            (GeneralFormTab.get('additionalInfo.commercialReg')?.dirty || GeneralFormTab.get('additionalInfo.commercialReg')?.touched)
                                        ">
                                            <div *ngIf="GeneralFormTab.get('additionalInfo.commercialReg')?.errors?.['required']">
                                                This field is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="chamberMembership" class="form-label fw-bold">Chamber of Commerce Membership Number</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="chamberMembership" formControlName="chamberMembership" placeholder="Enter chamber membership number" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="mb-3">
                                        <label for="importLicense" class="form-label fw-bold">COMMERCIAL License Number</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="importLicense" formControlName="importLicense" placeholder="Enter commercial license number" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- navigation buttons -->
            <!-- <div class="container">
              <div class="container">
                  <app-next-previous-back [currentTab]="currentTab" [totalTabs]="steps.length" (save)="onSave()" (next)="onNext()" (back)="onBack()"></app-next-previous-back>
              </div>
          </div> -->
        </form>

        <!-- Personal Information Tab -->
        <form *ngIf="steps[currentTab]?.title === 'PERSONAL INFORMATION' && personalInformationForm" [formGroup]="personalInformationForm">
            <!-- Vendor Details Section -->
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields">
                        <div class="mandatory-line">

                        </div>
                    </div>

                    <div class="container pt-4">
                        <div class="email-reg row">
                            <div class="col-12 col-md-6 d-flex">
                                <div class="acc-type-f fw-bold col-4">
                                    <span>Account type:</span>
                                </div>
                                <div class="acc-type-s col-8">
                                    <span>{{ vendor.vendorType }}</span>
                                    <!-- string >> Individual, Organization, Investor -->
                                </div>
                            </div>

                            <div class="col-12 col-md-6 d-flex pt-md-0 pt-4">
                                <div class="acc-type-f fw-bold col-4">
                                    <span>Local / Foreign:</span>
                                </div>
                                <div class="acc-type-s col-8">
                                    <span>{{ vendor.localOrForeign }}</span>
                                </div>
                            </div>

                        </div>
                        <br>

                        <div class="phone-num row">
                            <div class="col-12 col-md-6 d-flex">
                                <div class="acc-type-f fw-bold col-4">
                                    <span>{{vendor.vendorType == vendorType.Individual ? "Person Name" : "Company Name"  }}</span>
                                </div>
                                <div class="acc-type-s col-8">
                                    <span>{{ vendor.vendorName }}</span>
                                    <!-- string >> Individual, Organization, Investor -->
                                </div>
                            </div>

                            <div class="col-12 col-md-6 d-flex pt-md-0 pt-4">
                                <div class="acc-type-f fw-bold col-4">
                                    <span>VendorID: </span>
                                </div>
                                <div class="acc-type-s col-8">
                                    <span>{{ vendor.ERPVendorID }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields"></div>
                    <div class="container pt-4">
                        <!-- Full Name -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="fullName" class="form-label fw-bold">Full Name</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="fullName" formControlName="fullName" placeholder="Enter full name" [disabled]="isViewMode" />
                                    <div class="text-danger" *ngIf="
                                        personalInformationForm.get('fullName')?.invalid &&
                                        (personalInformationForm.get('fullName')?.dirty || personalInformationForm.get('fullName')?.touched)">
                                        <div *ngIf="personalInformationForm.get('fullName')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- National ID / Passport No. - Combined for non-Individual, Separate for Individual -->
                        <ng-container *ngIf="vendor?.vendorType !== 'Individual'">
                            <div class="row mb-4">
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="nationalIdPassport" class="form-label fw-bold">National ID / Passport No.</label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="nationalIdPassport" formControlName="nationalIdPassport" placeholder="Enter National ID or Passport Number" [disabled]="isViewMode"/>
                                        <div class="text-danger" *ngIf="
                                            personalInformationForm.get('nationalIdPassport')?.invalid &&
                                            (personalInformationForm.get('nationalIdPassport')?.dirty || personalInformationForm.get('nationalIdPassport')?.touched)">
                                            <div *ngIf="personalInformationForm.get('nationalIdPassport')?.errors?.['required']">
                                                This field is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="nationality" class="form-label fw-bold">Nationality</label>
                                        <select class="form-control rounded-4 bg-light p-2" formControlName="nationality" id="nationality" [disabled]="isViewMode">
                                            <option value="">Select Nationality</option>
                                        <option *ngFor="let country of Countries" [value]="country.countryRegionId">
                                            {{ country.countryName }}
                                        </option>
                                    </select>
                                    <div class="text-danger" *ngIf="
                                        personalInformationForm.get('nationality')?.invalid &&
                                        (personalInformationForm.get('nationality')?.dirty || personalInformationForm.get('nationality')?.touched)">
                                        <div *ngIf="personalInformationForm.get('nationality')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </ng-container>

                        <!-- Individual Type - Separate National ID and Passport -->
                        <ng-container *ngIf="vendor?.vendorType === 'Individual'">
                            <div class="row mb-4">
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="nationalId" class="form-label fw-bold">
                                            National ID
                                            <span *ngIf="personalInformationForm.get('localOrForeign')?.value?.toLowerCase() === 'local'" style="color: red;font-size: 1rem; margin-left: 2px;">*</span>
                                        </label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="nationalId" formControlName="nationalId" placeholder="Enter National ID" [disabled]="isViewMode"/>
                                        <div class="text-danger" *ngIf="
                                            personalInformationForm.get('nationalId')?.invalid &&
                                            (personalInformationForm.get('nationalId')?.dirty || personalInformationForm.get('nationalId')?.touched)">
                                            <div *ngIf="personalInformationForm.get('nationalId')?.errors?.['required']">
                                                This field is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="passportNo" class="form-label fw-bold">
                                            Passport No.
                                            <span *ngIf="personalInformationForm.get('localOrForeign')?.value?.toLowerCase() === 'foreign'" style="color: red;font-size: 1rem; margin-left: 2px;">*</span>
                                        </label>
                                        <input type="text" class="form-control rounded-4 bg-light p-2" id="passportNo" formControlName="passportNo" placeholder="Enter Passport Number" [disabled]="isViewMode"/>
                                        <div class="text-danger" *ngIf="
                                            personalInformationForm.get('passportNo')?.invalid &&
                                            (personalInformationForm.get('passportNo')?.dirty || personalInformationForm.get('passportNo')?.touched)">
                                            <div *ngIf="personalInformationForm.get('passportNo')?.errors?.['required']">
                                                This field is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="nationality" class="form-label fw-bold" appRequiredField="nationality">Nationality</label>
                                        <select class="form-control rounded-4 bg-light p-2" formControlName="nationality" id="nationality" [disabled]="isViewMode">
                                            <option value="">Select Nationality</option>
                                            <option *ngFor="let country of Countries" [value]="country.countryRegionId">
                                                {{ country.countryName }}
                                            </option>
                                        </select>
                                        <div class="text-danger" *ngIf="
                                            personalInformationForm.get('nationality')?.invalid &&
                                            (personalInformationForm.get('nationality')?.dirty || personalInformationForm.get('nationality')?.touched)">
                                            <div *ngIf="personalInformationForm.get('nationality')?.errors?.['required']">
                                                This field is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Date of Birth and Gender -->
                        <div class="row mb-4">
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="dateOfBirth" class="form-label fw-bold" appRequiredField="dateOfBirth">Date of Birth</label>
                                    <input type="date" class="form-control rounded-4 bg-light p-2" id="dateOfBirth" formControlName="dateOfBirth" [disabled]="isViewMode" />
                                    <div class="text-danger" *ngIf="
                                        personalInformationForm.get('dateOfBirth')?.invalid &&
                                        (personalInformationForm.get('dateOfBirth')?.dirty || personalInformationForm.get('dateOfBirth')?.touched)">
                                        <div *ngIf="personalInformationForm.get('dateOfBirth')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="gender" class="form-label fw-bold">Gender</label>
                                    <select class="form-control rounded-4 bg-light p-2" formControlName="gender" id="gender" [disabled]="isViewMode">
                                        <option value="">Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <div class="text-danger" *ngIf="
                                        personalInformationForm.get('gender')?.invalid &&
                                        (personalInformationForm.get('gender')?.dirty || personalInformationForm.get('gender')?.touched)">
                                        <div *ngIf="personalInformationForm.get('gender')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Residential Address -->
                        <div class="address-title mb-3">
                            <h4 class="fw-bold">Residential Address</h4>
                        </div>
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="residentialAddress" class="form-label fw-bold">Residential Address</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="residentialAddress" formControlName="residentialAddress" placeholder="Enter residential address" [disabled]="isViewMode"/>
                                    <div class="text-danger" *ngIf="
                                        personalInformationForm.get('residentialAddress')?.invalid &&
                                        (personalInformationForm.get('residentialAddress')?.dirty || personalInformationForm.get('residentialAddress')?.touched)">
                                        <div *ngIf="personalInformationForm.get('residentialAddress')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- City and Country -->
                        <div class="row mb-4">
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="personalCity" class="form-label fw-bold" appRequiredField="city">City</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="personalCity" formControlName="city" placeholder="Enter city" [disabled]="isViewMode"/>
                                    <div class="text-danger" *ngIf="
                                        personalInformationForm.get('city')?.invalid &&
                                        (personalInformationForm.get('city')?.dirty || personalInformationForm.get('city')?.touched)
                                    ">
                                        <div *ngIf="personalInformationForm.get('city')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="personalCountry" class="form-label fw-bold" appRequiredField="country">Country</label>
                                    <select class="form-control rounded-4 bg-light p-2" formControlName="country" id="personalCountry" [disabled]="isViewMode">
                                        <option value="">Choose Country</option>
                                        <option *ngFor="let country of Countries" [value]="country.countryRegionId">
                                            {{ country.countryName }}
                                        </option>
                                    </select>
                                    <div class="text-danger" *ngIf="
                                        personalInformationForm.get('country')?.invalid &&
                                        (personalInformationForm.get('country')?.dirty || personalInformationForm.get('country')?.touched)
                                    ">
                                        <div *ngIf="personalInformationForm.get('country')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Qatar Address Details -->
                        <div class="row mb-4">
                            <div class="col-12 col-md-4">
                                <div class="mb-3">
                                    <label for="personalZoneNo" class="form-label fw-bold">Zone No.<span *ngIf="isQatarCountry(personalInformationForm.get('country')?.value)" style="color: red; font-weight: bold; margin-left: 2px;">*</span></label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="personalZoneNo" formControlName="zoneNo" placeholder="Enter zone no" [disabled]="isViewMode"/>
                                    <div class="text-danger" *ngIf="personalInformationForm.get('zoneNo')?.invalid && (personalInformationForm.get('zoneNo')?.dirty || personalInformationForm.get('zoneNo')?.touched)">
                                        <div *ngIf="personalInformationForm.get('zoneNo')?.errors?.['required']">This field is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="mb-3">
                                    <label for="personalStreetNo" class="form-label fw-bold">Street No.<span *ngIf="isQatarCountry(personalInformationForm.get('country')?.value)" style="color: red; font-weight: bold; margin-left: 2px;">*</span></label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="personalStreetNo" formControlName="streetNo" placeholder="Enter street no" [disabled]="isViewMode"/>
                                    <div class="text-danger" *ngIf="personalInformationForm.get('streetNo')?.invalid && (personalInformationForm.get('streetNo')?.dirty || personalInformationForm.get('streetNo')?.touched)">
                                        <div *ngIf="personalInformationForm.get('streetNo')?.errors?.['required']">This field is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="mb-3">
                                    <label for="personalBuildingNo" class="form-label fw-bold">Building No.<span *ngIf="isQatarCountry(personalInformationForm.get('country')?.value)" style="color: red; font-weight: bold; margin-left: 2px;">*</span></label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="personalBuildingNo" formControlName="buildingNo" placeholder="Enter building no" [disabled]="isViewMode"/>
                                    <div class="text-danger" *ngIf="personalInformationForm.get('buildingNo')?.invalid && (personalInformationForm.get('buildingNo')?.dirty || personalInformationForm.get('buildingNo')?.touched)">
                                        <div *ngIf="personalInformationForm.get('buildingNo')?.errors?.['required']">This field is required</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Mobile Number and Email Address -->
                        <div class="row mb-4">
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <app-mobile-input [form]="personalInformationFormGroup" mobileControlName="mobileNumber" label="Mobile Number" labelClass="form-label fw-bold"></app-mobile-input>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="emailAddress" class="form-label fw-bold">Email Address</label>
                                    <input type="email" class="form-control rounded-4 bg-light p-2" id="emailAddress" formControlName="emailAddress" placeholder="Enter email address" [disabled]="isViewMode"/>
                                    <div class="text-danger" *ngIf="
                                        personalInformationForm.get('emailAddress')?.invalid &&
                                        (personalInformationForm.get('emailAddress')?.dirty || personalInformationForm.get('emailAddress')?.touched)
                                    ">
                                        <div *ngIf="personalInformationForm.get('emailAddress')?.errors?.['required']">
                                            This field is required
                                        </div>
                                        <div *ngIf="personalInformationForm.get('emailAddress')?.errors?.['email']">
                                            Please enter a valid email
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <!-- Business Information Tab -->
        <form *ngIf="steps[currentTab]?.title === 'BUSINESS INFORMATION' && businessInformationForm" [formGroup]="businessInformationForm">
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields"></div>
                    <div class="container pt-4">
                        <!-- Trading Name (if any) -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="tradingName" class="form-label fw-bold">Trading Name (if any)</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="tradingName" formControlName="tradingName" placeholder="Enter trading name" [disabled]="isViewMode"/>
                                </div>
                            </div>
                        </div>

                        <!-- Type of Business Activity -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="typeOfBusinessActivity" class="form-label fw-bold">Type of Business Activity</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="typeOfBusinessActivity" formControlName="typeOfBusinessActivity" placeholder="Enter type of business activity" [disabled]="isViewMode"/>
                                    <div class="text-danger" *ngIf="
                                        businessInformationForm.get('typeOfBusinessActivity')?.invalid &&
                                        (businessInformationForm.get('typeOfBusinessActivity')?.dirty || businessInformationForm.get('typeOfBusinessActivity')?.touched)
                                    ">
                                        <div *ngIf="businessInformationForm.get('typeOfBusinessActivity')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Years of Experience -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="yearsOfExperience" class="form-label fw-bold" appRequiredField="yearsOfExperience">Years of Experience</label>
                                    <input type="number" class="form-control rounded-4 bg-light p-2" id="yearsOfExperience" formControlName="yearsOfExperience" placeholder="Enter years of experience" min="0" [disabled]="isViewMode"/>
                                    <div class="text-danger" *ngIf="
                                        businessInformationForm.get('yearsOfExperience')?.invalid &&
                                        (businessInformationForm.get('yearsOfExperience')?.dirty || businessInformationForm.get('yearsOfExperience')?.touched)
                                    ">
                                        <div *ngIf="businessInformationForm.get('yearsOfExperience')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Description of Goods/Services Offered -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="descriptionOfGoodsServices" class="form-label fw-bold">Description of Goods/Services Offered</label>
                                    <textarea class="form-control rounded-4 bg-light p-2" id="descriptionOfGoodsServices" formControlName="descriptionOfGoodsServices" placeholder="Enter description of goods/services offered" rows="5" [disabled]="isViewMode"></textarea>
                                    <div class="text-danger" *ngIf="
                                        businessInformationForm.get('descriptionOfGoodsServices')?.invalid &&
                                        (businessInformationForm.get('descriptionOfGoodsServices')?.dirty || businessInformationForm.get('descriptionOfGoodsServices')?.touched)
                                    ">
                                        <div *ngIf="businessInformationForm.get('descriptionOfGoodsServices')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <!-- TAX & LEGAL Tab -->
        <form *ngIf="steps[currentTab]?.title === 'TAX & LEGAL' && taxLegalForm" [formGroup]="taxLegalForm">
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields"></div>
                    <div class="container pt-4">
                        <!-- Tax Identification Number (if applicable) -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="taxIdentificationNumber" class="form-label fw-bold">Tax Identification Number (if applicable)</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="taxIdentificationNumber" formControlName="taxIdentificationNumber" placeholder="Enter tax identification number" [disabled]="isViewMode"/>
                                </div>
                            </div>
                        </div>

                        <!-- VAT Registration No. (if applicable) -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="vatRegistrationNumber" class="form-label fw-bold">VAT Registration No. (if applicable)</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="vatRegistrationNumber" formControlName="vatRegistrationNumber" placeholder="Enter VAT registration number" [disabled]="isViewMode"/>
                                </div>
                            </div>
                        </div>

                        <!-- Country of Tax Residence -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="countryOfTaxResidence" class="form-label fw-bold">Country of Tax Residence</label>
                                    <select class="form-control rounded-4 bg-light p-2" formControlName="countryOfTaxResidence" id="countryOfTaxResidence" [disabled]="isViewMode">
                                        <option value="">Choose Country</option>
                                        <option *ngFor="let country of Countries" [value]="country.countryRegionId">{{ country.countryName }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        
        <!-- Company Ownership Tab -->
        <form *ngIf="steps[currentTab]?.title === 'Company Ownership' && companyOwnershipForm" [formGroup]="companyOwnershipForm">
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields">
                        <div class="mandatory-line">
                        </div>
                    </div>
                    <div class="container pt-4">
                        <div class="mandatory-line">
                            <span class="mandatory-par">
                                Mandatory fields below are marked with <span style="color: red;font-size: 1rem;">*</span>
                            </span>
                        </div>
                        <br>

                        <!-- Name of Owner -->
                        <div class="row mb-4">
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="ownerName" class="form-label fw-bold" appRequiredField="ownerName">Name of Owner</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="ownerName" formControlName="ownerName" placeholder="Enter owner name" />
                                    <div class="text-danger" *ngIf="companyOwnershipForm.get('ownerName')?.invalid && (companyOwnershipForm.get('ownerName')?.dirty || companyOwnershipForm.get('ownerName')?.touched)">
                                        <div *ngIf="companyOwnershipForm.get('ownerName')?.errors?.['required']">This field is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="ownerNationality" class="form-label fw-bold" appRequiredField="ownerNationality">Nationality</label>
                                    <select class="form-control rounded-4 bg-light p-2" id="ownerNationality" formControlName="ownerNationality" [disabled]="isViewMode">
                                        <option value="">Select Nationality</option>
                                        <option *ngFor="let country of Countries" [value]="country.countryRegionId">
                                            {{ country.countryName }}
                                        </option>
                                    </select>
                                    <div class="text-danger" *ngIf="companyOwnershipForm.get('ownerNationality')?.invalid && (companyOwnershipForm.get('ownerNationality')?.dirty || companyOwnershipForm.get('ownerNationality')?.touched)">
                                        <div *ngIf="companyOwnershipForm.get('ownerNationality')?.errors?.['required']">This field is required</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Partners/Co-Owners -->
                        <div class="address-title mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                                <h4 class="fw-bold mb-0">Please list the names of any Partners/Co-Owners of the business:</h4>
                                <button class="btn btn-add" *ngIf="!isViewMode" aria-label="Add Partner" (click)="addPartner()">
                                    Add <i class="bi bi-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div formArrayName="partners">
                            <div class="inner-card mb-3" *ngFor="let partner of partners.controls; let i = index" [formGroupName]="i">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'partnerName-' + i" class="form-label fw-bold" appRequiredField="name">Name</label>
                                            <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'partnerName-' + i" formControlName="name" placeholder="Enter name" />
                                            <div class="text-danger" *ngIf="
                                                partner.get('name')?.invalid &&
                                                (partner.get('name')?.dirty || partner.get('name')?.touched)
                                            ">
                                                <div *ngIf="partner.get('name')?.errors?.['required']">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'partnerPercentage-' + i" class="form-label fw-bold" appRequiredField="percentageOfShare">Percentage of Share Held</label>
                                            <div class="position-relative">
                                                <input type="text" class="form-control rounded-4 bg-light p-2 pe-4" [id]="'partnerPercentage-' + i" formControlName="percentageOfShare" placeholder="Enter percentage" style="padding-right: 2.5rem !important;" (input)="onPercentageInput($event, i)" />
                                                <span class="position-absolute" style="right: 1rem; top: 50%; transform: translateY(-50%); pointer-events: none; color: #6c757d;">%</span>
                                            </div>
                                            <div class="text-danger" *ngIf="
                                                partner.get('percentageOfShare')?.invalid &&
                                                (partner.get('percentageOfShare')?.dirty || partner.get('percentageOfShare')?.touched)
                                            ">
                                                <div *ngIf="partner.get('percentageOfShare')?.errors?.['required']">
                                                    This field is required
                                                </div>
                                                <div *ngIf="partner.get('percentageOfShare')?.errors?.['pattern']">
                                                    Please enter numbers only
                                                </div>
                                                <div *ngIf="partner.get('percentageOfShare')?.errors?.['maxPercentage']">
                                                    Percentage cannot exceed 100
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'partnerNationality-' + i" class="form-label fw-bold" appRequiredField="nationality">Nationality</label>
                                            <select class="form-control rounded-4 bg-light p-2" [id]="'partnerNationality-' + i" formControlName="nationality" [disabled]="isViewMode">
                                                <option value="">Select Nationality</option>
                                                <option *ngFor="let country of Countries" [value]="country.countryRegionId">
                                                    {{ country.countryName }}
                                                </option>
                                            </select>
                                            <div class="text-danger" *ngIf="
                                                partner.get('nationality')?.invalid &&
                                                (partner.get('nationality')?.dirty || partner.get('nationality')?.touched)
                                            ">
                                                <div *ngIf="partner.get('nationality')?.errors?.['required']">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'partnerIdNumber-' + i" class="form-label fw-bold" appRequiredField="idNumber">ID/CR number</label>
                                            <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'partnerIdNumber-' + i" formControlName="idNumber" placeholder="Enter ID/CR number" maxlength="14" />
                                            <div class="text-danger" *ngIf="
                                                partner.get('idNumber')?.invalid &&
                                                (partner.get('idNumber')?.dirty || partner.get('idNumber')?.touched)
                                            ">
                                                <div *ngIf="partner.get('idNumber')?.errors?.['required']">
                                                    This field is required
                                                </div>
                                                <div *ngIf="partner.get('idNumber')?.errors?.['pattern']">
                                                    ID/CR number must contain only digits
                                                </div>
                                                <div *ngIf="partner.get('idNumber')?.errors?.['maxlength']">
                                                    ID/CR number must be maximum 14 digits
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end align-items-center py-2">
                                    <a class="btn btn-save" (click)="deletePartner(i)" *ngIf="i !== 0 && !isViewMode">
                                        Delete
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- Senior Management -->
                        <div class="address-title mb-3 mt-4">
                            <div class="d-flex justify-content-between align-items-center">
                                <h4 class="fw-bold mb-0">Please list the Names and Titles of your Senior Management:</h4>
                                <button class="btn btn-add" *ngIf="!isViewMode" aria-label="Add Senior Management" (click)="addSeniorManagement()">
                                    Add <i class="bi bi-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div formArrayName="seniorManagement">
                            <div class="inner-card mb-3" *ngFor="let member of seniorManagement.controls; let i = index" [formGroupName]="i">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'managementName-' + i" class="form-label fw-bold" appRequiredField="name">Name</label>
                                            <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'managementName-' + i" formControlName="name" placeholder="Enter name" />
                                            <div class="text-danger" *ngIf="
                                                member.get('name')?.invalid &&
                                                (member.get('name')?.dirty || member.get('name')?.touched)
                                            ">
                                                <div *ngIf="member.get('name')?.errors?.['required']">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'managementTitle-' + i" class="form-label fw-bold" appRequiredField="title">Title</label>
                                            <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'managementTitle-' + i" formControlName="title" placeholder="Enter title" />
                                            <div class="text-danger" *ngIf="
                                                member.get('title')?.invalid &&
                                                (member.get('title')?.dirty || member.get('title')?.touched)
                                            ">
                                                <div *ngIf="member.get('title')?.errors?.['required']">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'managementNationality-' + i" class="form-label fw-bold" appRequiredField="nationality">Nationality</label>
                                            <select class="form-control rounded-4 bg-light p-2" [id]="'managementNationality-' + i" formControlName="nationality" [disabled]="isViewMode">
                                                <option value="">Select Nationality</option>
                                                <option *ngFor="let country of Countries" [value]="country.countryRegionId">
                                                    {{ country.countryName }}
                                                </option>
                                            </select>
                                            <div class="text-danger" *ngIf="
                                                member.get('nationality')?.invalid &&
                                                (member.get('nationality')?.dirty || member.get('nationality')?.touched)
                                            ">
                                                <div *ngIf="member.get('nationality')?.errors?.['required']">
This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label [for]="'managementEmail-' + i" class="form-label fw-bold" appRequiredField="email">Email</label>
                                            <input type="email" class="form-control rounded-4 bg-light p-2" [id]="'managementEmail-' + i" formControlName="email" placeholder="Enter email" />
                                            <div class="text-danger" *ngIf="
                                                member.get('email')?.invalid &&
                                                (member.get('email')?.dirty || member.get('email')?.touched)
                                            ">
                                                <div *ngIf="member.get('email')?.errors?.['required']">
                                                    This field is required
                                                </div>
                                                <div *ngIf="member.get('email')?.errors?.['email']">
                                                    Please enter a valid email
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <app-mobile-input [form]="$any(member)" mobileControlName="phoneNumber" [label]="'Phone No.'" labelClass="form-label fw-bold"></app-mobile-input>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <app-mobile-input [form]="$any(member)" mobileControlName="mobileNumber" [label]="'Mobile No.'" labelClass="form-label fw-bold"></app-mobile-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end align-items-center py-2">
                                    <a class="btn btn-save" (click)="deleteSeniorManagement(i)" *ngIf="i !== 0 && !isViewMode">
                                        Delete
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        
        <!-- Company background tab -->
        <!-- Financial Details Tab -->
        <form *ngIf="steps[currentTab]?.title === 'Financial Details' && financialDetailsForm" [formGroup]="financialDetailsForm">
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields"></div>
                    <div class="container pt-4">
                        <div class="mandatory-line">
                            <span class="mandatory-par">
                                Mandatory fields below are marked with <span style="color: red;font-size: 1rem;">*</span>
                            </span>
                        </div>
                        <br>

                        <!-- Static Fields -->
                        <div class="mb-3">
                            <label for="currency" class="form-label fw-bold">Currency <span style="color: red;font-size: 1rem;">*</span></label>
                            <select class="form-control rounded-4 bg-light p-2" id="currency" formControlName="currency" [disabled]="isViewMode">
                                <option value="">Select Currency</option>
                                <option *ngFor="let currency of Currencies" [value]="currency.currencyId">
                                    {{ currency.description }}
                                </option>
                            </select>
                            <div class="text-danger" *ngIf="financialDetailsForm.get('currency')?.invalid && (financialDetailsForm.get('currency')?.dirty || financialDetailsForm.get('currency')?.touched)">
                                <div *ngIf="financialDetailsForm.get('currency')?.errors?.['required']">
                                    This field is required
                                </div>
                            </div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="authorizedCapital" class="form-label fw-bold">{{ getFinancialFieldLabel('Authorized Capital') }} <span style="color: red;font-size: 1rem;">*</span></label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="authorizedCapital" formControlName="authorizedCapital" placeholder="Enter authorized capital" />
                                    <div class="text-danger" *ngIf="financialDetailsForm.get('authorizedCapital')?.invalid && (financialDetailsForm.get('authorizedCapital')?.dirty || financialDetailsForm.get('authorizedCapital')?.touched)">
                                        <div *ngIf="financialDetailsForm.get('authorizedCapital')?.errors?.['required']">
                                            This field is required
                                        </div>
                                        <div *ngIf="financialDetailsForm.get('authorizedCapital')?.errors?.['invalidNumber']">
                                            Only numbers are allowed
                                        </div>
                                        <div *ngIf="financialDetailsForm.get('authorizedCapital')?.errors?.['nonPositiveNumber']">
                                            Value must be greater than 0
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="creditRating" class="form-label fw-bold">Credit Rating (if applicable)</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="creditRating" formControlName="creditRating" placeholder="Enter credit rating" />
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="netProfit" class="form-label fw-bold">{{ getFinancialFieldLabel('Net Profit') }} <span style="color: red;font-size: 1rem;">*</span></label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="netProfit" formControlName="netProfit" placeholder="Enter net profit" />
                                    <div class="text-danger" *ngIf="financialDetailsForm.get('netProfit')?.invalid && (financialDetailsForm.get('netProfit')?.dirty || financialDetailsForm.get('netProfit')?.touched)">
                                        <div *ngIf="financialDetailsForm.get('netProfit')?.errors?.['required']">
                                            This field is required
                                        </div>
                                        <div *ngIf="financialDetailsForm.get('netProfit')?.errors?.['invalidNumber']">
                                            Only numbers are allowed
                                        </div>
                                        <div *ngIf="financialDetailsForm.get('netProfit')?.errors?.['zeroNumber']">
                                            Value cannot be 0
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="totalAssets" class="form-label fw-bold">{{ getFinancialFieldLabel('Total Assets') }} <span style="color: red;font-size: 1rem;">*</span></label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="totalAssets" formControlName="totalAssets" placeholder="Enter total assets" />
                                    <div class="text-danger" *ngIf="financialDetailsForm.get('totalAssets')?.invalid && (financialDetailsForm.get('totalAssets')?.dirty || financialDetailsForm.get('totalAssets')?.touched)">
                                        <div *ngIf="financialDetailsForm.get('totalAssets')?.errors?.['required']">
                                            This field is required
                                        </div>
                                        <div *ngIf="financialDetailsForm.get('totalAssets')?.errors?.['invalidNumber']">
                                            Only numbers are allowed
                                        </div>
                                        <div *ngIf="financialDetailsForm.get('totalAssets')?.errors?.['nonPositiveNumber']">
                                            Value must be greater than 0
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="currentRatio" class="form-label fw-bold">Current Ratio (Current Assets / Liabilities) <span style="color: red;font-size: 1rem;">*</span></label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="currentRatio" formControlName="currentRatio" placeholder="Enter current ratio" />
                                    <div class="text-danger" *ngIf="financialDetailsForm.get('currentRatio')?.invalid && (financialDetailsForm.get('currentRatio')?.dirty || financialDetailsForm.get('currentRatio')?.touched)">
                                        <div *ngIf="financialDetailsForm.get('currentRatio')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="latestAnnualTurnover" class="form-label fw-bold">{{ getFinancialFieldLabel('Latest Annual Turnover') }} <span style="color: red;font-size: 1rem;">*</span></label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="latestAnnualTurnover" formControlName="latestAnnualTurnover" placeholder="Enter latest annual turnover" />
                                    <div class="text-danger" *ngIf="financialDetailsForm.get('latestAnnualTurnover')?.invalid && (financialDetailsForm.get('latestAnnualTurnover')?.dirty || financialDetailsForm.get('latestAnnualTurnover')?.touched)">
                                        <div *ngIf="financialDetailsForm.get('latestAnnualTurnover')?.errors?.['required']">
                                            This field is required
                                        </div>
                                        <div *ngIf="financialDetailsForm.get('latestAnnualTurnover')?.errors?.['invalidNumber']">
                                            Only numbers are allowed
                                        </div>
                                        <div *ngIf="financialDetailsForm.get('latestAnnualTurnover')?.errors?.['nonPositiveNumber']">
                                            Value must be greater than 0
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Annual Turnover Section -->
                        <div class="address-title mb-3 mt-4">
                            <div class="d-flex justify-content-between align-items-center">
                                <h4 class="fw-bold mb-0">{{ getFinancialFieldLabel('Annual Turnover') }}:</h4>
                                <button class="btn btn-add" *ngIf="!isViewMode" aria-label="Add Annual Turnover" (click)="addAnnualTurnover()">
                                    Add <i class="bi bi-plus"></i>
                                </button>
                            </div>
                        </div>
                        
                        <!-- Current Year Field (Fixed, outside formArray) -->
                        <div class="mb-3">
                            <label for="currentYear" class="form-label fw-bold">Current Year <span style="color: red;font-size: 1rem;">*</span></label>
                            <div class="d-flex align-items-center">
                                <input type="number" class="form-control rounded-4 bg-light p-2" id="currentYear" formControlName="currentYear" placeholder="Select year" min="1900" max="2100" step="1" [readonly]="true" (keydown)="preventTyping($event)" (paste)="$event.preventDefault()" />
                                <div class="ms-2 d-flex flex-column" *ngIf="!isViewMode">
                                    <button type="button" class="btn btn-sm btn-outline-secondary mb-1 year-control-btn" 
                                            (mousedown)="startLongPress('increment')" (mouseup)="stopLongPress()" (mouseleave)="stopLongPress()"
                                            (touchstart)="startLongPress('increment')" (touchend)="stopLongPress()"
                                            [disabled]="isMaxYear()">
                                        <i class="bi bi-chevron-up"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-secondary year-control-btn" 
                                            (mousedown)="startLongPress('decrement')" (mouseup)="stopLongPress()" (mouseleave)="stopLongPress()"
                                            (touchstart)="startLongPress('decrement')" (touchend)="stopLongPress()">
                                        <i class="bi bi-chevron-down"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="text-danger" *ngIf="financialDetailsForm.get('currentYear')?.invalid && (financialDetailsForm.get('currentYear')?.dirty || financialDetailsForm.get('currentYear')?.touched)">
                                <div *ngIf="financialDetailsForm.get('currentYear')?.errors?.['required']">
                                    This field is required
                                </div>
                            </div>
                        </div>
                        
                        <!-- Year Fields (YR 1, YR 2, YR 3, YR 4, YR 5, etc.) -->
                        <div formArrayName="annualTurnovers">
                            <div class="row">
                                <div class="col-12 col-md-6 mb-3" *ngFor="let turnover of annualTurnovers.controls; let i = index" [formGroupName]="i">
                                    <label [for]="'year-' + i" class="form-label fw-bold" appRequiredField="value">YR {{ turnover.get('yearNumber')?.value }} {{ getYearForTurnover(turnover.get('yearNumber')?.value) }}</label>
                                    <div class="year-field-container">
                                        <input type="number" class="form-control rounded-4 bg-light p-2" [id]="'year-' + i" formControlName="value" [placeholder]="'Enter YR ' + turnover.get('yearNumber')?.value" [class.year-input-with-delete]="!isViewMode && turnover.get('yearNumber')?.value > 3" (input)="limitAnnualTurnoverLength($event, i)" />
                                        <button *ngIf="!isViewMode && turnover.get('yearNumber')?.value > 3" type="button" class="btn btn-link text-danger year-delete-btn" (click)="deleteAnnualTurnover(i)" aria-label="Delete Year">
                                            <i class="bi bi-x-circle-fill"></i>
                                        </button>
                                    </div>
                                    <div class="text-danger" *ngIf="
                                        turnover.get('value')?.invalid &&
                                        (turnover.get('value')?.dirty || turnover.get('value')?.touched)
                                    ">
                                        <div *ngIf="turnover.get('value')?.errors?.['required']">
                                            This field is required
                                        </div>
                                        <div *ngIf="turnover.get('value')?.errors?.['invalidNumber']">
                                            Only numbers are allowed
                                        </div>
                                        <div *ngIf="turnover.get('value')?.errors?.['nonPositiveNumber']">
                                            Value must be greater than 0
                                        </div>
                                        <div *ngIf="turnover.get('value')?.errors?.['maxlength']">
                                            Maximum 18 characters allowed
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <!-- Capability & Experience Tab -->
        <form *ngIf="steps[currentTab]?.title === 'Capability & Experience' && capabilityExperienceForm" [formGroup]="capabilityExperienceForm">
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields"></div>
                    <div class="container pt-4">
                        <div class="mandatory-line">
                            <span class="mandatory-par">
                                Mandatory fields below are marked with <span style="color: red;font-size: 1rem;">*</span>
                            </span>
                        </div>
                        <br>

                        <!-- Core Products/Services offered -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="coreProductsServices" class="form-label fw-bold">Core Products/Services offered</label>
                                    <input type="text" class="form-control rounded-4 bg-light p-2" id="coreProductsServices" formControlName="coreProductsServices" placeholder="Enter core products/services" />
                                </div>
                            </div>
                        </div>

                        <!-- Previous Experience -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="previousExperience" class="form-label fw-bold">Previous Experience</label>
                                    <textarea class="form-control rounded-4 bg-light p-2" id="previousExperience" formControlName="previousExperience" placeholder="Enter previous experience" rows="4"></textarea>
                                </div>
                            </div>
                        </div>

                        <!-- Categories and SubCategories Side by Side -->
                        <div class="row mb-4">
                            <!-- Categories and SubCategories Tree -->
                            <div class="col-12">
                                <div class="mb-3">
                                    <label class="form-label fw-bold mb-3" appRequiredField="categories">Categories & SubCategories</label>
                                    <div class="category-tree-container" [ngClass]="{ 'disabled': isViewMode, 'is-invalid': categoriesValidationError || subCategoriesValidationError }">
                                        <!-- Tree Structure -->
                                        <div *ngIf="categoryTree && categoryTree.length > 0; else fallbackTree" class="tree-wrapper">
                                            <div *ngFor="let category of categoryTree" class="tree-category-wrapper">
                                                <!-- Category Node -->
                                                <div class="tree-category-row" [ngClass]="{ 'has-children': category.subCategories && category.subCategories.length > 0, 'selected': isProductCategorySelected(category) }">
                                                    <div class="tree-category-content" (click)="!isViewMode && toggleProductCategorySelection(category)">
                                                        <span class="tree-check-icon">
                                                            <i [class]="isProductCategorySelected(category) ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
                                                        </span>
                                                        <label class="tree-category-label">{{ category.description }}</label>
                                                    </div>
                                                    <button type="button" 
                                                            class="tree-expand-btn" 
                                                            *ngIf="category.subCategories && category.subCategories.length > 0"
                                                            (click)="toggleCategoryExpand(category.categoryId); $event.stopPropagation()"
                                                            [attr.aria-expanded]="isCategoryExpanded(category.categoryId)">
                                                        <i [class]="isCategoryExpanded(category.categoryId) ? 'bi bi-chevron-down' : 'bi bi-chevron-right'"></i>
                                                    </button>
                                                </div>
                                                <!-- SubCategories (nested) -->
                                                <div class="tree-subcategories-wrapper" *ngIf="isCategoryExpanded(category.categoryId) && category.subCategories && category.subCategories.length > 0">
                                                    <div *ngFor="let subCategory of category.subCategories" 
                                                         class="tree-subcategory-wrapper">
                                                        <!-- SubCategory Row -->
                                                        <div class="tree-subcategory-row" 
                                                             [ngClass]="{ 'has-children': subCategory.subSubCategories && subCategory.subSubCategories.length > 0, 'selected': isWorksCategorySelected(subCategory) }">
                                                            <div class="tree-subcategory-content" (click)="!isViewMode && toggleWorksCategorySelection(subCategory)">
                                                                <span class="tree-check-icon">
                                                                    <i [class]="isWorksCategorySelected(subCategory) ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
                                                                </span>
                                                                <label class="tree-subcategory-label">{{ subCategory.description }}</label>
                                                            </div>
                                                            <button type="button" 
                                                                    class="tree-expand-btn" 
                                                                    *ngIf="subCategory.subSubCategories && subCategory.subSubCategories.length > 0"
                                                                    (click)="toggleSubCategoryExpand(subCategory.subCategoryId); $event.stopPropagation()"
                                                                    [attr.aria-expanded]="isSubCategoryExpanded(subCategory.subCategoryId)">
                                                                <i [class]="isSubCategoryExpanded(subCategory.subCategoryId) ? 'bi bi-chevron-down' : 'bi bi-chevron-right'"></i>
                                                            </button>
                                                        </div>
                                                        <!-- SubSubCategories (third level) -->
                                                        <div class="tree-subsubcategories-wrapper" *ngIf="isSubCategoryExpanded(subCategory.subCategoryId) && subCategory.subSubCategories && subCategory.subSubCategories.length > 0">
                                                            <div *ngFor="let subSubCategory of subCategory.subSubCategories" 
                                                                 class="tree-subsubcategory-row" 
                                                                 [ngClass]="{ 'selected': isSubSubCategorySelected(subSubCategory) }"
                                                                 (click)="!isViewMode && toggleSubSubCategorySelection(subSubCategory)">
                                                                <span class="tree-check-icon">
                                                                    <i [class]="isSubSubCategorySelected(subSubCategory) ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
                                                                </span>
                                                                <label class="tree-subsubcategory-label">{{ subSubCategory.description }}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- Add "Other" option for subcategories if not already present -->
                                                    <div *ngIf="!hasOtherInSubCategories() && isProductCategorySelected(category)" 
                                                         class="tree-subcategory-row" 
                                                         [ngClass]="{ 'selected': isWorksCategorySelected('Other') }"
                                                         (click)="!isViewMode && toggleWorksCategorySelection({subCategoryId: 'Other', categoryId: category.categoryId})">
                                                        <span class="tree-check-icon">
                                                            <i [class]="isWorksCategorySelected('Other') ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
                                                        </span>
                                                        <label class="tree-subcategory-label">Other</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Add "Other" option for categories if not already present -->
                                            <div *ngIf="!hasOtherInCategories()" class="tree-category-wrapper">
                                                <div class="tree-category-row" [ngClass]="{ 'selected': isProductCategorySelected('Other') }">
                                                    <div class="tree-category-content" (click)="!isViewMode && toggleProductCategorySelection('Other')">
                                                        <span class="tree-check-icon">
                                                            <i [class]="isProductCategorySelected('Other') ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
                                                        </span>
                                                        <label class="tree-category-label">Other</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <ng-template #fallbackTree>
                                            <div class="tree-wrapper">
                                                <div *ngIf="Categories && Categories.length > 0">
                                                    <div *ngFor="let category of Categories" class="tree-category-wrapper">
                                                        <div class="tree-category-row" [ngClass]="{ 'selected': isProductCategorySelected(category) }">
                                                            <div class="tree-category-content" (click)="!isViewMode && toggleProductCategorySelection(category)">
                                                                <span class="tree-check-icon">
                                                                    <i [class]="isProductCategorySelected(category) ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
                                                                </span>
                                                                <label class="tree-category-label">{{ category.description || category.Description || category.name || category.Name }}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div *ngIf="!Categories || Categories.length === 0" class="text-muted p-3">
                                                    No categories available. Please refresh the page or contact support.
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <!-- Validation error messages -->
                                    <div class="text-danger mt-2" *ngIf="categoriesValidationError">
                                        <small>{{ categoriesValidationError }}</small>
                                    </div>
                                    <div class="text-danger mt-2" *ngIf="subCategoriesValidationError">
                                        <small>{{ subCategoriesValidationError }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Additional Information and Contracts/Projects Details -->
                        <div class="row mb-4">
                            <div class="col-12 col-md-6">
                                <div class="mb-3 d-flex flex-column">
                                    <label for="additionalInformation" class="form-label fw-bold" style="min-height: 48px;">Provide additional information about your Products or Services if required</label>
                                    <textarea class="form-control rounded-4 bg-light p-2" id="additionalInformation" formControlName="additionalInformation" rows="5" placeholder="Enter additional information" [disabled]="isViewMode"></textarea>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3 d-flex flex-column">
                                    <label for="contractsProjectsDetails" class="form-label fw-bold" appRequiredField="contractsProjectsDetails" style="min-height: 48px;">Please provide details of list of contracts/projects for the category that you are applying completed in the last three year</label>
                                    <textarea class="form-control rounded-4 bg-light p-2" id="contractsProjectsDetails" formControlName="contractsProjectsDetails" rows="5" placeholder="Enter contracts/projects details" [disabled]="isViewMode"></textarea>
                                    <div class="text-danger" *ngIf="
                                        capabilityExperienceForm.get('contractsProjectsDetails')?.invalid &&
                                        (capabilityExperienceForm.get('contractsProjectsDetails')?.dirty || capabilityExperienceForm.get('contractsProjectsDetails')?.touched)
                                    ">
                                        <div *ngIf="capabilityExperienceForm.get('contractsProjectsDetails')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Authorized Representative/Dealer Question -->
                        <div class="mb-4">
                            <div class="mb-3">
                                <div class="d-flex align-items-center gap-3 flex-wrap">
                                    <span class="form-label fw-bold mb-0">
                                        Do you have, or are you, an authorized representative/dealer for any supplier (local or foreign)?:
                                    </span>
                                    <div class="d-flex gap-3 align-items-center">
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="radio" name="isAuthorizedRepresentative" id="isAuthorizedRepresentativeYes" [value]="true" formControlName="isAuthorizedRepresentative" />
                                            <label class="form-check-label" for="isAuthorizedRepresentativeYes">
                                                Yes
                                            </label>
                                        </div>
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="radio" name="isAuthorizedRepresentative" id="isAuthorizedRepresentativeNo" [value]="false" formControlName="isAuthorizedRepresentative" />
                                            <label class="form-check-label" for="isAuthorizedRepresentativeNo">
                                                No
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Authorized Representative/Dealer Section -->
                        <div class="mb-4" *ngIf="capabilityExperienceForm.get('isAuthorizedRepresentative')?.value === true">
                            <div class="address-title mb-3 mt-4">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h4 class="fw-bold mb-0">If yes, please provide details in table below: Authorized Representative for:</h4>
                                    <button class="btn btn-add" *ngIf="!isViewMode" aria-label="Add Authorized Representative" (click)="addAuthorizedRepresentative()">
                                        Add <i class="bi bi-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div formArrayName="authorizedRepresentatives">
                                <div class="inner-card mb-3" *ngFor="let representative of authorizedRepresentatives.controls; let i = index" [formGroupName]="i">
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <div class="mb-3">
                                                <label [for]="'company-' + i" class="form-label fw-bold" appRequiredField="company">Company</label>
                                                <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'company-' + i" formControlName="company" placeholder="Enter company name" />
                                                <div class="text-danger" *ngIf="representative.get('company')?.invalid && (representative.get('company')?.dirty || representative.get('company')?.touched)">
                                                    <div *ngIf="representative.get('company')?.errors?.['required']">
                                                        This field is required
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <div class="mb-3">
                                                <label [for]="'poBox-' + i" class="form-label fw-bold" appRequiredField="poBox">P.O Box</label>
                                                <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'poBox-' + i" formControlName="poBox" placeholder="Enter P.O Box" />
                                                <div class="text-danger" *ngIf="representative.get('poBox')?.invalid && (representative.get('poBox')?.dirty || representative.get('poBox')?.touched)">
                                                    <div *ngIf="representative.get('poBox')?.errors?.['required']">
                                                        This field is required
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <div class="mb-3">
                                                <label [for]="'telNo-' + i" class="form-label fw-bold" appRequiredField="telNo">Tel. No.</label>
                                                <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'telNo-' + i" formControlName="telNo" placeholder="Enter Tel. No." />
                                                <div class="text-danger" *ngIf="representative.get('telNo')?.invalid && (representative.get('telNo')?.dirty || representative.get('telNo')?.touched)">
                                                    <div *ngIf="representative.get('telNo')?.errors?.['required']">
                                                        This field is required
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <div class="mb-3">
                                                <label [for]="'faxNo-' + i" class="form-label fw-bold">Fax No.</label>
                                                <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'faxNo-' + i" formControlName="faxNo" placeholder="Enter Fax No." />
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <div class="mb-3">
                                                <label [for]="'productsRepresented-' + i" class="form-label fw-bold" appRequiredField="productsRepresented">Products Represented</label>
                                                <input type="text" class="form-control rounded-4 bg-light p-2" [id]="'productsRepresented-' + i" formControlName="productsRepresented" placeholder="Enter products represented" />
                                                <div class="text-danger" *ngIf="representative.get('productsRepresented')?.invalid && (representative.get('productsRepresented')?.dirty || representative.get('productsRepresented')?.touched)">
                                                    <div *ngIf="representative.get('productsRepresented')?.errors?.['required']">
                                                        This field is required
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <app-file-upload #fileUpload 
                                                [label]="'Upload File'" 
                                                [inputId]="'authorized-rep-file-' + i" 
                                                [placeholderText]="'Click or drag the file here to upload'" 
                                                [multiple]="false" 
                                                [isRequired]="true" 
                                                [formControl]="getAuthorizedRepresentativeFileControl(i)" 
                                                [disabled]="isViewMode"
                                                (fileUploaded)="onFileUpload($event, 'authorizedRepFile_' + i)" 
                                                (fileRemoved)="handleFileRemove('authorizedRepFile_' + i)" 
                                                (allFilesUploaded)="onAllFilesUploaded()">
                                            </app-file-upload>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end align-items-center py-2">
                                        <a class="btn btn-save" (click)="deleteAuthorizedRepresentative(i)" *ngIf="!isViewMode">
                                            Delete
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <!-- Compliance & Ethics Tab -->
        <form *ngIf="steps[currentTab]?.title === 'Compliance & Ethics' && OtherDocuments" [formGroup]="OtherDocuments">
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields">
                        <div class="mandatory-line">

                        </div>
                    </div>
                    <div class="container pt-4">
                        <div class="mandatory-line">
                            <span class="mandatory-par">
                                Mandatory fields below are marked with <span style="color: red;font-size: 1rem;">*</span>
                            </span>
                        </div>
                        <br>
                        
                        <!-- All documents from DocumentsMaster will be rendered dynamically -->
                        <div class="prime-address">
                            <div *ngFor="let document of DocumentsMaster" class="document-field row">

                                <!-- File Upload Section -->

                                <!-- Dynamic File Upload Component -->
                                <div *ngIf="getDocumentFormControl(document.documentName)" class="document-upload-field col-12 col-md-6 pt-2">
                                    <app-file-upload #fileUpload [label]="document.documentName" [inputId]="'document-upload-input-' + document.documentName" [placeholderText]="'Click or drag the file here to upload'" [multiple]="document.allowMultipleDocs" [isRequired]="document.mandatory || document.expirationDate"
                                        [formControl]="getDocumentFormControl(document.documentName)" [disabled]="isViewMode" (fileUploaded)="onFileUpload($event, document.documentName)" (fileRemoved)="handleFileRemove(document.documentName)" (allFilesUploaded)="onAllFilesUploaded()">
                                    </app-file-upload>



                                </div>

                                <!-- Expiration Date Section (if applicable) -->
                                <div *ngIf="document.expirationDate" class="expiration-date-container col-12 col-md-6 pt-2">
                                    <div class="mb-3 expiration-date-section">
                                        <label [for]="'expiration-date-input-' + document.documentName" [appRequiredField]="document.documentName + 'Date'" class="expiration-date-label form-label fw-bold">
                                            Expiry date
                                        </label>
                                        <!-- Check if the control exists in the form group -->
                                        <input *ngIf="OtherDocuments?.get(document.documentName + 'Date')" type="date" [formControlName]="document.documentName + 'Date'" class="expiration-date-input p-2 form-control rounded-4 bg-light" [id]="'expiration-date-input-' + document.documentName"
                                            [placeholder]="'Enter expiration date'" (blur)="OtherDocuments.get(document.documentName + 'Date')?.markAsTouched()" (change)="OtherDocuments.get(document.documentName + 'Date')?.markAsTouched()" />
                                        <div class="text-danger" *ngIf="OtherDocuments?.get(document.documentName + 'Date')?.invalid && (OtherDocuments?.get(document.documentName + 'Date')?.dirty || OtherDocuments?.get(document.documentName + 'Date')?.touched)">
                                            <div *ngIf="OtherDocuments?.get(document.documentName + 'Date')?.errors?.['required']">This field is required.</div>
                                            <div *ngIf="OtherDocuments?.get(document.documentName + 'Date')?.errors?.['pastDate']">Past date not allowed.</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <!-- Supporting Documents Tab -->
        <form *ngIf="steps[currentTab]?.title === 'Supporting Documents' && supportingDocumentsForm" [formGroup]="supportingDocumentsForm">
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields"></div>
                    <div class="container pt-4">
                        <div class="mandatory-line">
                            <span class="mandatory-par">
                                Mandatory fields below are marked with <span style="color: red;font-size: 1rem;">*</span>
                            </span>
                        </div>
                        <br>

                        <!-- All documents from DocumentsMaster will be rendered dynamically -->
                        <div class="prime-address">
                            <div *ngFor="let document of DocumentsMaster" class="document-field row">
                                <!-- File Upload Section -->
                                <div *ngIf="getSupportingDocumentControl(document.documentName)" class="document-upload-field col-12 col-md-6 pt-2">
                                    <app-file-upload #fileUpload [label]="document.documentName" [inputId]="'document-upload-input-' + document.documentName" [placeholderText]="'Click or drag the file here to upload'" [multiple]="document.allowMultipleDocs" [isRequired]="document.mandatory || document.expirationDate"
                                        [formControl]="getSupportingDocumentControl(document.documentName)" [disabled]="isViewMode" (fileUploaded)="onFileUpload($event, document.documentName)" (fileRemoved)="handleFileRemove(document.documentName, $event)" (allFilesUploaded)="onAllFilesUploaded()">
                                    </app-file-upload>
                                </div>

                                <!-- Expiration Date Section (if applicable) -->
                                <div *ngIf="document.expirationDate && !isSupportingPerFileExpiryDocument(document.documentName)" class="expiration-date-container col-12 col-md-6 pt-2">
                                    <div class="mb-3 expiration-date-section">
                                        <label [for]="'expiration-date-input-' + document.documentName" [appRequiredField]="document.documentName + 'Date'" class="expiration-date-label form-label fw-bold">
                                            Expiry date
                                        </label>
                                        <input *ngIf="supportingDocumentsForm?.get(document.documentName + 'Date')" type="date" [formControlName]="document.documentName + 'Date'" class="expiration-date-input p-2 form-control rounded-4 bg-light" [id]="'expiration-date-input-' + document.documentName"
                                            [placeholder]="'Enter expiration date'" (blur)="supportingDocumentsForm.get(document.documentName + 'Date')!.markAsTouched()" (change)="supportingDocumentsForm.get(document.documentName + 'Date')!.markAsTouched()" />
                                        <div class="text-danger" *ngIf="supportingDocumentsForm?.get(document.documentName + 'Date')?.invalid && (supportingDocumentsForm?.get(document.documentName + 'Date')?.dirty || supportingDocumentsForm?.get(document.documentName + 'Date')?.touched)">
                                            <div *ngIf="supportingDocumentsForm?.get(document.documentName + 'Date')?.errors?.['required']">This field is required.</div>
                                            <div *ngIf="supportingDocumentsForm?.get(document.documentName + 'Date')?.errors?.['pastDate']">Past date not allowed.</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Per-file Expiration Dates for supporting documents that require per-file expiry -->
                                <div *ngIf="shouldShowSupportingPerFileExpiry(document) && getSupportingPerFileAttachments(document.documentName, true).length > 0" class="expiration-date-container col-12 col-md-6 pt-2">
                                    <div>
                                        <div class="mb-3 expiration-date-section" *ngFor="let attachment of getSupportingPerFileAttachments(document.documentName, true)">
                                            <label [for]="'expiration-date-input-' + document.documentName + '-' + attachment.Name" class="expiration-date-label form-label fw-bold">
                                                Expiry date for {{ attachment.Name }} <span *ngIf="isSupportingPerFileExpiryMandatory(document.documentName)" style="color: red;font-size: 1rem;">*</span>
                                            </label>
                                            <input type="date" [formControlName]="getSupportingPerFileExpiryControlName(document.documentName, attachment.Name)" class="expiration-date-input p-2 form-control rounded-4 bg-light" [id]="'expiration-date-input-' + document.documentName + '-' + attachment.Name"
                                                [placeholder]="'Enter expiration date'" (blur)="supportingDocumentsForm.get(getSupportingPerFileExpiryControlName(document.documentName, attachment.Name))?.markAsTouched()" (change)="supportingDocumentsForm.get(getSupportingPerFileExpiryControlName(document.documentName, attachment.Name))?.markAsTouched()" />
                                            <div class="text-danger" *ngIf="supportingDocumentsForm?.get(getSupportingPerFileExpiryControlName(document.documentName, attachment.Name))?.invalid && (supportingDocumentsForm?.get(getSupportingPerFileExpiryControlName(document.documentName, attachment.Name))?.dirty || supportingDocumentsForm?.get(getSupportingPerFileExpiryControlName(document.documentName, attachment.Name))?.touched)">
                                                <div *ngIf="supportingDocumentsForm?.get(getSupportingPerFileExpiryControlName(document.documentName, attachment.Name))?.errors?.['required']">This field is required.</div>
                                                <div *ngIf="supportingDocumentsForm?.get(getSupportingPerFileExpiryControlName(document.documentName, attachment.Name))?.errors?.['pastDate']">Past date not allowed.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <!-- Warehousing & Storage Tab -->
        <form *ngIf="steps[currentTab]?.title === 'Warehousing & Storage' && warehousingStorageForm" [formGroup]="warehousingStorageForm">
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields"></div>
                    <div class="container pt-4">
                        <!-- Warehousing and Storage Facilities -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="warehousingStorageDetails" class="form-label fw-bold">Please provide details of your warehousing and storage facilities including location:</label>
                                    <textarea class="form-control rounded-4 bg-light p-2" id="warehousingStorageDetails" formControlName="warehousingStorageDetails" rows="5" placeholder="Enter details of your warehousing and storage facilities including location" [disabled]="isViewMode"></textarea>
                                </div>
                            </div>
                        </div>

                        <!-- Transport/Freight Forwarding Facilities -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="transportFreightForwardingDetails" class="form-label fw-bold">Please provide details of your transport/freight forwarding facilities:</label>
                                    <textarea class="form-control rounded-4 bg-light p-2" id="transportFreightForwardingDetails" formControlName="transportFreightForwardingDetails" rows="5" placeholder="Enter details of your transport/freight forwarding facilities" [disabled]="isViewMode"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <!-- Banking Details Tab -->
        <form *ngIf="isAbleTBankApplication && bankAccountForm && steps[currentTab]?.title === 'Banking Details'" [formGroup]="bankAccountForm">
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields">
                        <div class="mandatory-line">

                        </div>
                    </div>
                    <div class="container pt-4">
                        <div class="mandatory-line">
                            <span class="mandatory-par">
                                Mandatory fields below are marked with <span style="color: red;font-size: 1rem;">*</span>
                            </span>
                        </div>
                        <br>
                        <div class="address-title">
                            <h4 class="fw-bold">Bank account</h4>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6 pt-2">
                                <div class="mb-3">
                                    <label for="bank-name-input" class="form-label fw-bold" appRequiredField="bankName">Bank Name</label>
                                    <select class="city-input p-2 form-control rounded-4 bg-light" id="bankName" formControlName="bankName" (change)="onBankChange()" [disabled]="isViewMode">
                                        <option value="" selected disabled>Choose Bank</option>
                                        <option *ngFor="let bank of Banks" [value]="bank.bankId">
                                            {{ bank.description }}
                                        </option>
                                        <option value="other">Other (Please specify)</option>
                                    </select>
                                    <div class="text-danger" *ngIf="
                                        bankAccountForm.get('bankName')?.invalid &&
                                        (bankAccountForm.get('bankName')?.dirty || bankAccountForm.get('bankName')?.touched)
                                    ">
                                        <div *ngIf="bankAccountForm.get('bankName')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 pt-2">
                                <div class="mb-3">
                                    <label for="bank-account-input" class="form-label fw-bold" appRequiredField="accountNumber">Bank Account No</label>
                                    <input type="text" formControlName="accountNumber" class="city-input p-2 form-control rounded-4 bg-light" id="bank-account-input" placeholder="Enter your bank account" [disabled]="isViewMode">


                                </div>
                            </div>

                            <!-- Conditionally show "Other Bank" input if "other" is selected -->
                            <div *ngIf="showOtherBank" class="col-12 col-md-6 pt-2">
                                <div class="mb-3">
                                    <label for="other-bank-name-input" appRequiredField="otherBankName" class="form-label fw-bold">Specify Other Bank Name</label>
                                    <input type="text" class="city-input p-2 form-control rounded-4 bg-light" id="otherBankName" formControlName="otherBankName" placeholder="Enter Bank Name" [disabled]="isViewMode" />
                                    <div class="text-danger" *ngIf="
                                        bankAccountForm.get('otherBankName')?.invalid &&
                                        (bankAccountForm.get('otherBankName')?.dirty || bankAccountForm.get('otherBankName')?.touched)
                                    ">
                                        <div *ngIf="bankAccountForm.get('otherBankName')?.errors?.['required']">
                                            This field is required
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-12 col-md-6 pt-2">
                                <div class="mb-3">
                                    <label for="iban-input" class="form-label fw-bold" appRequiredField="iban">IBAN
                        </label>
                                    <input type="text" formControlName="iban" class="city-input p-2 form-control rounded-4 bg-light" id="iban-input" placeholder="Enter your IBAN" maxlength="34" (input)="onIbanInput($event)" />
                                    <div class="text-danger" *ngIf="
                                        bankAccountForm.get('iban')?.invalid &&
                                        (bankAccountForm.get('iban')?.dirty || bankAccountForm.get('iban')?.touched)
                                    ">
                                        <div *ngIf="bankAccountForm.get('iban')?.errors?.['required']">
                                            This field is required
                                        </div>
                                        <div *ngIf="bankAccountForm.get('iban')?.errors?.['pattern']">
                                            IBAN must contain only uppercase letters and numbers
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 pt-2">
                                <div class="mb-3">
                                    <label for="swift-code-input" class="form-label fw-bold" appRequiredField="swiftCode">Swift Code/BIC
                        </label>
                                    <input type="text" formControlName="swiftCode" class="city-input p-2 form-control rounded-4 bg-light" id="swift-code-input" placeholder="Enter your Swift code / BIC">


                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-6 pt-2">
                                <div class="mb-3">
                                    <label for="branch-name-input" class="form-label fw-bold" appRequiredField="branchName">Branch Name
                      </label>
                                    <input type="text" formControlName="branchName" class="city-input p-2 form-control rounded-4 bg-light" id="branch-name-input" placeholder="Enter branch name">

                                </div>
                            </div>
                            <div class="col-12 col-md-6 pt-2">
                                <div class="mb-3">
                                    <label for="beneficiary-account-input" class="form-label fw-bold" appRequiredField="benficeryName">Beneficiary Account Name</label>
                                    <input type="text" formControlName="benficeryName" class="city-input p-2 form-control rounded-4 bg-light" id="beneficiary-account-input" placeholder="Enter beneficiary account" required>

                                </div>
                            </div>


                            <div class="secondary-address">
                    

                                <div class="postal-code-secondary row">
                                    <!-- <div class="postal-code-input-container-secondary col-12 col-md-6 pt-2">
                                        <div class="mb-3 postal-code-section-secondary">
                                            <label for="postal-code-input-secondary" class="cpostal-code-label-secondary form-label fw-bold" appRequiredField="sortCode">Sort Code</label>
                                            <input type="text" formControlName="sortCode" class="postal-code-input-secondary p-2 form-control rounded-4 bg-light" id="postal-code-input-secondary" placeholder="Enter your Sort Code">
                                        </div>
                                    </div> -->

                                    <div class="country-input-container col-12 col-md-6 pt-2">
                                        <div class="mb-3 country-section">
                                            <label for="country-input" class="country-label form-label fw-bold" appRequiredField="bankCountry">Country</label>

                                            <select class="country-input p-2 form-control rounded-4 bg-light" formControlName="bankCountry" id="country-input">
                                              <option value="" selected disabled>Choose country</option>
                                              <option *ngFor="let country of Countries" [value]="country.countryRegionId">
                                                  {{ country.countryName }}
                                              </option>
                                          </select>
                                        </div>
                                    </div>


                                    <div class="postal-code-input-container-secondary col-12 col-md-6 pt-2">
                                        <div class="mb-3 postal-code-section-secondary">
                                            <label for="Currency-code-input-secondary" class="cpostal-code-label-secondary form-label fw-bold" appRequiredField="currency">Currency</label>

                                            <select class="postal-code-input-secondary p-2 form-control rounded-4 bg-light ng-untouched ng-pristine ng-invalid" id="Currency" formControlName="currency" id="Currency-code-input-secondary" placeholder="Enter account currency">
                                              <option value="" selected disabled>Choose Currency</option>
                                                <option *ngFor="let Currencys of Currencies" [value]="Currencys.currencyId">  
                                                {{ Currencys.description }}
                                                </option>
                                           </select>


                                        </div>
                                    </div>
                                </div>

                                <div class="city-field-secondary row">
                                    <div class="city-input-container-secondary col-12 col-md-6 pt-2">
                                        <div class="mb-3 city-section-secondary">
                                            <label for="city-input-secondary" class="city-label-secondary form-label fw-bold" appRequiredField="email">Email for financial communication</label>
                                            <input type="email" formControlName="email" class="city-input-secondary p-2 form-control rounded-4 bg-light" id="email-input-secondary" placeholder="e.g. finance@company.com">
                                            <div class="text-danger" *ngIf="
                                                bankAccountForm.get('email')?.invalid &&
                                                (bankAccountForm.get('email')?.dirty || bankAccountForm.get('email')?.touched)
                                            ">
                                                <div *ngIf="bankAccountForm.get('email')?.errors?.['required']">This field is required.</div>
                                                <div *ngIf="bankAccountForm.get('email')?.errors?.['email']">Please enter a valid email address.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="country-field-secondary col-12 col-md-6 pt-2">
                                        <div class="mb-3 country-section-secondary">
                                            <label for="country-input-secondary" class="country-label-secondary form-label fw-bold" appRequiredField="address">Address</label>
                                            <textarea type="text" formControlName="address" class="city-input-secondary p-2 form-control rounded-4 bg-light" id="address-input-secondary" placeholder="Address">
                                            </textarea>
                                        </div>
                                    </div>

                                    <div class="country-field-secondary col-12 col-md-6 pt-2">
                                        <div class="mb-3 country-section-secondary">
                                            <label for="country-input-secondary" class="country-label-secondary form-label fw-bold">Active date</label>
                                            <input type="date" formControlName="ActiveDate" class="city-input-secondary p-2 form-control rounded-4 bg-light" id="ActiveDate" placeholder="ActiveDate">
                                        </div>
                                    </div>

                                    <div class="country-field-secondary col-12 col-md-6 pt-2">
                                        <div class="mb-3 country-section-secondary">
                                            <label for="ExpiryDate" class="country-label-secondary form-label fw-bold">Expiry date</label>
                                            <input type="date" formControlName="ExpiryDate" class="city-input-secondary p-2 form-control rounded-4 bg-light" id="ExpiryDate" placeholder="ExpiryDate" [disabled]="isViewMode">
                                        </div>
                                    </div>

                                </div>

                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <app-file-upload #fileUpload [label]="'Attach Company Bank Details on (COMPANY LETTER HEAD), signed by an Authorized Signatory as per the Establishment Card.'" [inputId]="'document-upload-input-Document'" [placeholderText]="'Click or drag the file here to upload'" [multiple]="true" [isRequired]="true" [formControl]="documentFormControl" [disabled]="isViewMode"
                                            (fileUploaded)="onFileUpload($event, 'Document')" (fileRemoved)="handleFileRemove('Document')" (allFilesUploaded)="onAllFilesUploaded()">
                                        </app-file-upload>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <app-file-upload #bankCertificateUpload [label]="'Bank Certificate'" [inputId]="'document-upload-input-bankCertificate'" [placeholderText]="'Click or drag the file here to upload'" [multiple]="true" [isRequired]="true" [formControl]="bankCertificateFormControl" [disabled]="isViewMode"
                                            (fileUploaded)="onFileUpload($event, 'bankCertificate')" (fileRemoved)="handleFileRemove('bankCertificate')" (allFilesUploaded)="onAllFilesUploaded()">
                                        </app-file-upload>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>



        <!-- Other Tab -->
        <form *ngIf="steps[currentTab]?.title === 'Other' && otherInformationForm" [formGroup]="otherInformationForm">
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="mandatory-fields"></div>
                    <div class="container pt-4">
                        <!-- Other Information -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="otherInformation" class="form-label fw-bold">Provide any other information that you think Bidaya should consider as part of your application:</label>
                                    <textarea class="form-control rounded-4 bg-light p-2" id="otherInformation" formControlName="otherInformation" rows="5" placeholder="Enter any other information" [disabled]="isViewMode"></textarea>
                                </div>
                            </div>
                        </div>

                        <!-- Confirmation Checkbox -->
                        <div class="form-check mt-4 other-step-checkbox">
                            <input type="checkbox" id="confirmCheckbox" [formControl]="confirmCheckboxControl" class="form-check-input" (click)="CheckBoxAgreement()" [disabled]="isViewMode">
                            <label class="form-check-label" for="confirmCheckbox">
                                I hereby confirm the accuracy of the information provided in this Vendor Registration and the validity of all accompanying documents. Bidaya reserves the right to verify all submitted documents and application information as deemed necessary.
                            </label>

                            <div *ngIf="confirmCheckboxControl.invalid && (confirmCheckboxControl.dirty || confirmCheckboxControl.touched)" class="text-danger">
                                <small *ngIf="confirmCheckboxControl.errors?.['custom']">
                                    {{ confirmCheckboxControl.errors?.['custom'] }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <app-next-previous-back [currentTab]="currentTab" [isViewMode]="isViewMode" [totalTabs]="steps.length" (next)="onNext()" (back)="onBack()" (save)="onSave()" [nextButtonDisabled]="isSubmitDisabled()" [showNextButton]="!isPageLoading && steps.length > 0">
        </app-next-previous-back>
    </div>
</div>
